import { createFileRoute } from '@tanstack/react-router';

import { Security } from '@/features/settings';

export const Route = createFileRoute('/_auth/settings/security')({
  component: Security,
});
